import request from '@/utils/request';
import { apiBase } from '@/utils/config';
/*
* 产业链金融
* */

// 文件上传返回URL
export function uploadFileUrl() {
  return `${apiBase}/common/addfileurl`;
}

// 获取所属产业链
export function getIndustryChain() {
  return request({
    url: '/agricultural/finance/chain/application/industry/init',
    method: 'GET',
  });
}

// 获取项目名称
export function getProjectName() {
  return request({
    url: '/agricultural/finance/chain/application/project/init',
    method: 'GET',
  });
}

// 产业链金融申请
export function addApply(data) {
  return request({
    url: '/agricultural/finance/chain/application/add',
    method: 'POST',
    data,
  });
}

// 供应链关系确认-数据统计
export function getOrderCount(data) {
  return request({
    url: '/agricultural/finance/chain/application/confirm/count',
    method: 'POST',
    data,
  });
}

// 供应链关系确认列表
export function getOrderList(data) {
  return request({
    url: '/agricultural/finance/chain/application/confirm/list',
    method: 'POST',
    data,
  });
}

// 供应链关系确认
export function confirmRelation(data) {
  return request({
    url: '/agricultural/finance/chain/application/confirm',
    method: 'POST',
    data,
  });
}

// 产业链金融申报列表
export function getDeclareList(data) {
  return request({
    url: '/agricultural/finance/chain/application/declare/list',
    method: 'POST',
    data,
  });
}

// 获取上下游企业列表
export function getApplicantList() {
  return request({
    url: '/agricultural/finance/chain/application/applicant/init',
    method: 'GET',
  });
}

// 获取产业链金融申请详情
export function getApplicationDetail(id, applicantId) {
  return request({
    url: '/agricultural/finance/chain/application/detail',
    method: 'GET',
    params: { id, type: 1, applicantId },
  });
}

// 更新产业链金融申请
export function updateBackApply(data) {
  return request({
    url: '/agricultural/finance/chain/application/edit',
    method: 'POST',
    data,
  });
}

// 取消申请
export function cancelApplication(id) {
  return request({
    url: '/agricultural/finance/chain/application/cancle',
    method: 'POST',
    data: { id },
  });
}

// 获取产业链列表
export function getIndustryChains() {
  return request({
    url: '/supply/chain/industryChains',
    method: 'GET',
  });
}

// 根据产业链获取项目列表
export function getIndustryChainBelongs(industryChainBelongs) {
  return request({
    url: '/supply/chain/industryChainBelongs',
    method: 'GET',
    params: { industryChainBelongs },
  });
}

// 获取贷款银行列表
export function getLoanBanks(projectId) {
  return request({
    url: '/supply/chain/loan/banks',
    method: 'GET',
    params: { projectId },
  });
}

// 获取保险机构列表
export function getInsuranceInstitutions(projectId) {
  return request({
    url: '/supply/chain/insurance/loan/banks',
    method: 'GET',
    params: { projectId },
  });
}

// 获取保险产品列表
export function getInsuranceProducts(orgId, billionAgriProjectId) {
  return request({
    url: '/supply/chain/insurance/loan/products',
    method: 'GET',
    params: { orgId, billionAgriProjectId },
  });
}

// 融资申请提交
export function addMajorFinancing(data) {
  return request({
    url: '/supply/chain/add/major',
    method: 'POST',
    data,
  });
}

// 保险融资申请提交
export function addInsuranceFinancing(data) {
  return request({
    url: '/supply/chain/insurance/add/major',
    method: 'POST',
    data,
  });
}

// 获取产业链金融详情
export function getSupplyChainFinancingDetail(id) {
  return request({
    url: '/supply/chain/financing/detail',
    method: 'GET',
    params: { id },
  });
}

// 获取保险融资详情
export function getInsuranceFinancingDetail(id) {
  return request({
    url: '/supply/chain/insurance/financing/detail',
    method: 'GET',
    params: { id },
  });
}
